<template>
  <div class="flex-grow-1 padding">
    <h4 class="mt-0">
      Zoekmachineoptimalisatie
    </h4>
    <p>
      Verbeter uw rangschikking en hoe uw productpagina verschijnt in de zoekresultaten.<br>
      Hierbij een voorvertoning van het zoekresultaat. van de zoekmachine, pas dit gerust eens aan!
    </p>

    <SeoFields
      :description.sync="$v.seo_meta_description.$model"
      :title.sync="$v.seo_meta_title.$model"
      :url.sync="$v.url.$model"
    >
      <template #url-tip>
        <span v-if="canAutoGenerateUrl">
          U kunt automatisch een URL genereren door het veld "Productnaam" in te vullen.
        </span>
      </template>
    </SeoFields>

    <CardTabs
      :tabs="tabs"
      v-model="tabState"
      class="card-tabs mt-4"
    />

    <GenericCrud v-if="tabState === 'seo-headlines'"
      v-model="seo_headlines"
      inputPlaceholder="SEO-kop..."
      @input="val => $emit('update:seo_headlines', val)"
      new-item-message="Nieuwe kop toevoegen."
    />
    <GenericCrud v-else-if="tabState === 'seo-descriptions'"
      v-model="seo_descriptions"
      inputPlaceholder="SEO-beschrijving..."
      @input="val => $emit('update:seo_descriptions', val)"
      new-item-message="SEO-beschrijving toevoegen."
    />
    <GenericCrud v-else-if="tabState === 'seo-keywords'"
      v-model="keywords"
      inputPlaceholder="SEO-zoekwoord..."
      @input="val => $emit('update:keywords', val)"
      new-item-message="Nieuw zoekwoord toevoegen."
    />
  </div>
</template>

<script>

import FormInput from "../../../Inputs/FormInput.vue"
import FormTextarea from "../../../Inputs/FormTextarea.vue"

import CardTabs from "../../../../layout/CardTabs.vue"
import GenericCrud from "../../../../layout/GenericCrud/GenericCrud.vue"

import SeoFields from "../../../../layout/SeoFields.vue"

import setupForm from "../../../../mixins/setupForm"

const fields = ["seo_meta_title", "seo_meta_description", "url", "seo_headlines", "seo_descriptions", "keywords"]

// this.$v.url.$model = encodeURIComponent(productName.toLowerCase().replace(/ /g, '-'))

export default setupForm(fields, {
  props: {
    productId: String,
    productName: String,
    initialData: Object

  },
  components: {
    FormInput,
    FormTextarea,
    SeoFields,
    CardTabs,
    GenericCrud
  },
  data() {
    return {
      tabState: 'seo-headlines',
      seo_headlines: [],
      seo_descriptions: [],
      keywords: [],
    }
  },
  computed: {
    canAutoGenerateUrl() {
      return !this.productId
    },
    tabs() {
      return [
        {
          name: "SEO Krantenkoppen",
          id: "seo-headlines",
        },
        {
          name: "SEO Beschrijvingen",
          id: "seo-descriptions",
        },
        {
          name: "SEO-zoekwoorden",
          id: "seo-keywords",
        },
      ]
    },
  },
  watch: {
    productName(productName) {
      // if (this.canAutoGenerateUrl) {
        this.url = encodeURIComponent(productName.toLowerCase().replace(/ /g, '-'))
        this.seo_meta_title = productName
      // }
    },
  },
  // Remove "true"!
}, null, true)

</script>

<style scoped>

.form-url {
  margin-bottom: 0px;
}

h5 {
  font-size: 20px;
  color: #141AA4;
  font-weight: 550;
}

.preview {
  word-break: break-all;
  word-wrap: break-word;
}


.preview div {
  color: #2A642A;
}

.preview p {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  max-width: 800px;
}

.label {
  margin-top: -15px;
}

</style>
